import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import TechnicalStandards from "./sections/TechnicalStandards";
import Metodo from "./sections/Metodo";
import Interventi from "./sections/Interventi";
import Inspection from "./sections/Inspection";
import Sopralluogo from "./sections/Sopralluogo";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <Hero />
      <TechnicalStandards />
      <Metodo />
      <Interventi />
      <Inspection />
      <Sopralluogo />
      <Footer />
    </div>;
}